import React, {useContext, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation, Navigate} from "react-router-dom";

import {APIS} from '../../config/apis';
import {APPCONFIG} from '../../app.config';
import {useForm, useFormErrors, useNav, useUnsavedChangesGuard, useReporte} from '../../components/hooks';
import { ALERT_TYPE, CUENTA_STATE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {ServerRequest} from '../../utils/apiweb';

import {Loading, SectionHeading, SectionSidebar} from '../../components/common';
import {ManagedContext} from '../../context/custom';
import {MESSAGE_MODALS} from '../../context/custom/MessageModalContext';
import {getDateId} from '../../utils/convert';
import {CloneObject,OpenObjectURL} from '../../utils/helpers';
import {MenuLateral, SectionForm} from './components';
import {
    AddFondeadero,
    buildFondeaderoEntityInit,
    FindFondeadero,
    MakeListDomiciliosRelacionados,
    ModifyFondeadero,
    UpdateEntityRow
} from './utils';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {PERMISSIONS} from '../../consts/permissions';

function FondeaderoView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const {showMessageModal} = useContext(ManagedContext)

    //variables
    const CAMPOS_TRIBUTO = ['embarcacion', 'superficie', 'longitud', 'codigo', 'club', 'digitoVerificador', 'ubicacion', 'margen', 'fechaAlta'];
    const entityInit = buildFondeaderoEntityInit();
    const menuesInit = {
        expedientes: false,
        certificadosEscribanos: false,
        relacionesCuentas: false,
        controladoresCuentas: false,
        zonasEntrega: false,
        aplicacionCreditos: false,
        condonacion: false,
        pagosAnticipados: false,
        planesPago: false
    };

    //hooks
    const navigate = useNav()

    const [state, setState] = useState({
        processKey: `Fondeadero_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        menues: menuesInit,
        showMenu: false,
        tabActive: "declaracionesJuradas",
        tabActiveElementos: ""
    });

    const [toggledSidebarLeft, setToggledSidebarLeft] = useState(true);
    const [pendingChange, setPendingChange] = useState(state.mode === OPERATION_MODE.NEW);

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);
    const navigateAllowed = (navOptions) => {
        allowNavigation();
        navigate(navOptions);
    };

    const mount = () => {
        // alta obsoleta: en modo NEW el guard redirige a la grilla, no inicializar ni avisar
        if (state.mode === OPERATION_MODE.NEW) return;
        if (state.id > 0) {
            FindFondeadero(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindFondeadero);
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
        }
    }
    useEffect(mount, []);

    const [listExpedientes, setListExpedientes] = useState([]);

    const updateListExpedientes = () => {
        var list = []
        const listsWithExpediente = [
            ...state.entity.recargosDescuentos
        ];
        listsWithExpediente.filter(f => f.state !== 'r').forEach(x => {
            if (x.idExpediente && x.idExpediente > 0 && list.indexOf(x.idExpediente) === -1) list.push(x.idExpediente)
        });

        setListExpedientes(list);
    }

    useEffect(updateListExpedientes, [state.entity.recargosDescuentos]);

    const [listDireccionesRelacionadas, setListDireccionesRelacionadas] = useState([]);
    const updateListDireccionesRelacionadas = () => {
        MakeListDomiciliosRelacionados(state.entity.vinculosFondeadero)
            .then(list => {
                setListDireccionesRelacionadas(list);
            })
            .catch((error) => {
                const message = `Error consultando domicilios: ${error.message}`;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }
    useEffect(updateListDireccionesRelacionadas, [state.entity.vinculosFondeadero]);

    const [fondeadero_formValues, fondeadero_formHandle, , fondeadero_formSet] = useForm({
        idEstadoCarga: 20,
        idTasa: 0,
        idSubTasa: 0,
        idTipoFondeadero: 0,
        embarcacion: "",
        superficie: "",
        longitud: "",
        codigo: "",
        club: "",
        digitoVerificador: "",
        ubicacion: "",
        margen: "",
        fechaAlta: null
    }, 'fondeadero_');

    const [cuentaOpen, setCuentaOpen] = useState(true);
    const [tributoOpen, setTributoOpen] = useState(false);
    const [estadoOpen, setEstadoOpen] = useState(false);

    const [cuenta_formValues, cuenta_formHandle, , cuenta_formSet] = useForm({
        numeroCuenta: '',
        numeroWeb: ''
    }, 'cuenta_');

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const cuenta_formHandleProxy = (event) => {
        cuenta_formHandle(event);
        setPendingChange(true);
    }
    const fondeadero_formHandleProxy = (event) => {
        fondeadero_formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        const errors = getErrors();
        if (errors.idTipoFondeadero) setCuentaOpen(true);
        if (CAMPOS_TRIBUTO.some(campo => errors[campo])) setTributoOpen(true);
        if (errors.idEstadoCarga) setEstadoOpen(true);
        if (!validate()) return;

        if (state.id === 0) {
            AddFondeadero(state, setState, fondeadero_formValues, cuenta_formValues, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError);
        } else {
            ModifyFondeadero(state, setState, dataTagger, fondeadero_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindFondeadero);
        }
    };
    const handleClickBaja = () => {
        const idCuenta = state.entity.cuenta.id;
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: "Al aceptar el cambio se procederá con la baja de la cuenta.",
            onConfirm: () => ModifyBajaCuenta(idCuenta, state, setState, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError)
        })
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindFondeadero = (response) => {
        response.json()
            .then((data) => {

                //deserialize date fields
                if (data.fondeadero.fechaCargaInicio) data.fondeadero.fechaCargaInicio = new Date(data.fondeadero.fechaCargaInicio);
                if (data.fondeadero.fechaCargaFin) data.fondeadero.fechaCargaFin = new Date(data.fondeadero.fechaCargaFin);
                if (data.fondeadero.fechaAlta) data.fondeadero.fechaAlta = new Date(data.fondeadero.fechaAlta);
                if (data.cuenta.fechaAlta) data.cuenta.fechaAlta = new Date(data.cuenta.fechaAlta);
                if (data.cuenta.fechaBaja) data.cuenta.fechaBaja = new Date(data.cuenta.fechaBaja);

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.variablesCuenta.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.vinculosFondeadero.forEach(x => {
                    if (x.fechaInstrumentoDesde) x.fechaInstrumentoDesde = new Date(x.fechaInstrumentoDesde);
                    if (x.fechaInstrumentoHasta) x.fechaInstrumentoHasta = new Date(x.fechaInstrumentoHasta);
                });
                data.condicionesEspeciales.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.recargosDescuentos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                    if (x.fechaOtorgamiento) x.fechaOtorgamiento = new Date(x.fechaOtorgamiento);
                });
                data.debitosAutomaticos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.elementos.forEach(x => {
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.declaracionesJuradas.forEach(x => {
                    if (x.fechaPresentacionDeclaracionJurada) x.fechaPresentacionDeclaracionJurada = new Date(x.fechaPresentacionDeclaracionJurada);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);
                fondeadero_formSet({
                    idEstadoCarga: data.fondeadero.idEstadoCarga,
                    idTasa: data.fondeadero.idTasa,
                    idSubTasa: data.fondeadero.idSubTasa,
                    idTipoFondeadero: data.fondeadero.idTipoFondeadero,
                    embarcacion: data.fondeadero.embarcacion,
                    superficie: data.fondeadero.superficie,
                    longitud: data.fondeadero.longitud,
                    codigo: data.fondeadero.codigo,
                    club: data.fondeadero.club,
                    digitoVerificador: data.fondeadero.digitoVerificador,
                    ubicacion: data.fondeadero.ubicacion,
                    margen: data.fondeadero.margen,
                    fechaAlta: data.fondeadero.fechaAlta
                });
                cuenta_formSet({
                    numeroCuenta: data.cuenta.numeroCuenta,
                    numeroWeb: data.cuenta.numeroWeb
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    //funciones
    function getErrors() {
        const errors = {};

        if (fondeadero_formValues.idEstadoCarga === 0) errors.idEstadoCarga = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (fondeadero_formValues.idTipoFondeadero <= 0) errors.idTipoFondeadero = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (state.mode === OPERATION_MODE.EDIT) {
            if (fondeadero_formValues.embarcacion === "") errors.embarcacion = VALIDATION_MESSAGE.REQUIRED;
            if (fondeadero_formValues.superficie === "") errors.superficie = VALIDATION_MESSAGE.REQUIRED_SHORT;
            if (fondeadero_formValues.longitud === "") errors.longitud = VALIDATION_MESSAGE.REQUIRED_SHORT;
            if (fondeadero_formValues.codigo === "") errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT;
            if (fondeadero_formValues.club === "") errors.club = VALIDATION_MESSAGE.REQUIRED_SHORT;
            if (fondeadero_formValues.digitoVerificador === "") errors.digitoVerificador = VALIDATION_MESSAGE.REQUIRED_SHORT;
            if (fondeadero_formValues.ubicacion === "") errors.ubicacion = VALIDATION_MESSAGE.REQUIRED;
            if (fondeadero_formValues.margen === "") errors.margen = VALIDATION_MESSAGE.REQUIRED;
            if (fondeadero_formValues.fechaAlta === null) errors.fechaAlta = VALIDATION_MESSAGE.REQUIRED_SHORT;
        }

        return errors;
    }

    function ModifyBajaCuenta(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La cuenta fue dada de baja correctamente", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        const url = '/fondeadero/' + OPERATION_MODE.VIEW + '/' + row.idTributo;
                        allowNavigation();
                        navigate({
                            to: `/fondeadero/${OPERATION_MODE.VIEW}/${row.idTributo}`,
                            refresh: true,
                            replace: true,
                        })
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/baja/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CUENTA,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs
        let entity = CloneObject(state.entity);

        UpdateEntityRow(typeEntity, row, entity);

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }

    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    function SetTabActiveElementos(tab) {
        setState(prevState => {
            return {...prevState, tabActiveElementos: tab};
        });
    }

    function ShowPopupMenu(menu) {
        let menues = CloneObject(menuesInit);
        menues[menu] = true;
        setState(prevState => {
            return {...prevState, showMenu: true, menues: menues};
        });
    }

    function HidePopupMenu() {
        setState(prevState => {
            return {...prevState, showMenu: false, menues: menuesInit};
        });
    }

    function ShowPage(partialUrl) {
        const url = APPCONFIG.SITE.WEBAPP + partialUrl + '/' + state.mode + '/' + state.entity.cuenta.id;
        window.open(url, '_blank');
    }

    function refetchFondeadero() {
        setState(x => ({...x, loading: true}))
        setTimeout(() => {
            FindFondeadero(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindFondeadero)
        }, 2000)
    }

    // La ficha sale completa y sin diálogo de opciones (contrato del Epic LAR-2347),
    // así que el menú la descarga directo en vez de abrir un modal.
    const [generateFicha, ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const listMenu = [

        {
            menu: '1', items: [
                {
                    title: 'Expedientes', icon: 'draft', onClick: () => {
                        ShowPopupMenu('expedientes')
                    }
                },
                {
                    title: 'Ficha del fondeadero', icon: 'description', onClick: () => {
                        generateFicha('CuentaFicha', {idCuenta: state.entity.cuenta.id})
                    }
                }
            ]
        },

        {
            menu: '2', items: [
                {
                    title: 'Gestión', icon: 'gavel', items: [
                        {
                            title: 'Certificados escribanos', onClick: () => {
                                ShowPopupMenu('certificadosEscribanos')
                            }
                        },
                        {
                            title: 'Relaciones', onClick: () => {
                                ShowPopupMenu('relacionesCuentas')
                            }
                        },
                        {
                            title: 'Controladores', onClick: () => {
                                ShowPopupMenu('controladoresCuentas')
                            }
                        },
                        {
                            title: 'Zonas entregas', onClick: () => {
                                ShowPopupMenu('zonasEntrega')
                            }
                        }
                    ]
                },
                {
                    title: 'Movimientos', icon: 'calculate', items: [
                        {
                            title: 'Cuenta corriente', onClick: () => {
                                ShowPage('cuenta-corriente/cuenta')
                            }, permisos: [PERMISSIONS.CUENTA_CORRIENTE_VIEW]
                        },
                        {
                            title: 'Créditos', onClick: () => {
                                ShowPopupMenu('aplicacionCreditos')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT, PERMISSIONS.CREDITO_EDIT]
                        },
                        {
                            title: 'Condonaciones', onClick: () => {
                                ShowPopupMenu('condonacion')
                            }, permisos: [PERMISSIONS.CONDONACION_EDIT]
                        },
                        {
                            title: 'Deuda', onClick: () => {
                                ShowPage('deuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Planes de pago', onClick: () => {
                                ShowPopupMenu('planesPago')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Liquidaciones', onClick: () => {
                                ShowPopupMenu('liquidaciones')
                            }, permisos: [PERMISSIONS.EMISION_EDIT, PERMISSIONS.LIQUIDACION_VIEW]
                        },
                        {
                            // pago-derecho-especial/:idCuenta no sigue el esquema de ShowPage (partialUrl/mode/id), por eso usamos window.open directo.
                            title: 'Derechos especiales', onClick: () => {
                                window.open(`${APPCONFIG.SITE.WEBAPP}pago-derecho-especial/${state.entity.cuenta.id}`, '_blank')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT]
                        },
                        {
                            title: 'Informe de deuda', onClick: () => {
                                ShowPopupMenu('informeDeuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        }
                    ]
                }
            ]
        },

    ];

    // El alta es por modal desde la grilla; /fondeadero/new queda obsoleta.
    if (state.mode === OPERATION_MODE.NEW) return <Navigate to={'/fondeaderos' + location.search} replace />;

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {state.showMenu &&
                <MenuLateral
                    state={state}
                    listExpedientes={listExpedientes}
                    listDireccionesRelacionadas={listDireccionesRelacionadas}
                    UpdateEntity={UpdateEntity}
                    HidePopupMenu={HidePopupMenu}
                />
            }

            <div className='section-frames'>

                <div className='section-sidebar-left'>
                    <SectionSidebar
                        collapsed={toggledSidebarLeft}
                        listMenu={listMenu}
                    />
                </div>

                <div className='section-main'>

                    <SectionHeading
                        handleToggleSidebar={(state.mode !== OPERATION_MODE.NEW) ? () => {
                            setToggledSidebarLeft(prevState => !prevState)
                        } : null}
                        isSidebarOpen={!toggledSidebarLeft}
                        titles={[
                            {title: 'Tributos'},
                            {title: 'Administración de fondeaderos', url: '/fondeaderos'},
                            {title: params.mode === OPERATION_MODE.NEW ? 'Nuevo' : `Número de cuenta: ${cuenta_formValues.numeroCuenta}`}
                        ]}
                    />

                    <SectionForm
                        SetTabActive={SetTabActive}
                        setPendingChange={setPendingChange}
                        state={state}
                        fondeadero_formValues={fondeadero_formValues}
                        fondeadero_formHandleProxy={fondeadero_formHandleProxy}
                        cuenta_formValues={cuenta_formValues}
                        cuenta_formHandleProxy={cuenta_formHandleProxy}
                        UpdateEntity={UpdateEntity}
                        handleClickBaja={handleClickBaja}
                        errorOf={errorOf}
                        cuentaOpen={cuentaOpen}
                        setCuentaOpen={setCuentaOpen}
                        tributoOpen={tributoOpen}
                        setTributoOpen={setTributoOpen}
                        estadoOpen={estadoOpen}
                        setEstadoOpen={setEstadoOpen}
                        pendingChange={pendingChange}
                        refetchFondeadero={refetchFondeadero}
                    />

                </div>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver pendingChange={pendingChange} processKey={state.processKey}
                                        to="/fondeaderos" allowNavigation={allowNavigation}/>
                    {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                        <button className="btn action-button float-start m-left-20"
                                onClick={(event) => handleClickBaja()}>Baja</button>
                    }
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default FondeaderoView;

